const featureFR = {
    "view": {
        "table": {
            "title": "Demandes de fonctionnalité",
            "column": {
                "release_name": "Nom",
                "release_artist_name": "Nom de l'artiste de la sortie",
                "release_date": "Date de sortie",
                "exclusive_date": "Date exclusive"
            },
            "button": {
                "export_csv": "Exporter CSV"
            },
            "placeholder": {
                "search": "Recherche..."
            }
        },
        "message": {
            "subscriptionUpgrade": "Votre plan d'abonnement actuel ne prend pas en charge cette fonctionnalité. Veuillez <1>mettre à niveau</1> votre plan d'abonnement pour bénéficier de cette fonctionnalité.",
            "subscriptionExpired": "Votre abonnement a expiré. Veuillez <1>reprendre</1> votre abonnement pour bénéficier de cette fonctionnalité.",
            "noAccess": "Vous n'avez pas accès à ce module, veuillez contacter l'équipe de support pour plus d'informations."
        }
    },
    "add": {
        "title": "Faits de marketing",
        "form": {
            "label": {
                "release": "Sortie",
                "djTastemaker": "Retours DJ / TasteMaker :",
                "radioSupport": "Support radio",
                "marketingPR": "Marketing / Pr",
                "labelReach": "Portée du label et des artistes :"
            },
            "help_text": {
                "release": "Sélectionnez une sortie pour laquelle vous souhaitez soumettre une demande de mise en avant. Vous ne pouvez voir et sélectionner que les sorties ayant une date de sortie générale 22 jours ou plus à l'avance. Si vous visez une date de sortie exclusive, veuillez vous assurer de soumettre ce formulaire au moins 22 jours avant une (première) date de sortie exclusive.",
                "djTastemaker": "Insérez 10 retours DJ / Radio / Magazine au format 'Nom - Retour' (Insérez chaque retour sur une ligne). Les soumissions contenant 'téléchargement pour' ne seront pas promues ou envoyées aux boutiques en ligne.",
                "radioSupport": "Votre chanson ou sortie est-elle diffusée sur certaines stations de radio ? Si oui, nommez la station et insérez le lien correspondant vers leur page où il est visible qu'ils promeuvent ou diffusent vos chansons.",
                "marketingPR": "(Interviews, blogs, critiques, articles de magazines) - Veuillez lister toutes les activités de presse et de marketing prévues pour cette sortie. Non obligatoire mais essentiellement important pour se démarquer de la concurrence.",
                "labelReach": "Le nombre total (label et artistes) de followers sur Facebook, Instagram, SoundCloud et YouTube. <strong>Veuillez mettre chaque plateforme et le nombre de followers sur une nouvelle ligne</strong>."
            },
            "button": {
                "submit": "Soumettre"
            },
            "message": {
                "releaseRequired": "Une sortie existante est requise",
                "featureRequestAlreadyExists": "Une demande de fonctionnalité pour cette sortie a déjà été faite"
            }
        },
        "message": {
            "success": "La demande de fonctionnalité a été ajoutée !",
            "error": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !"
        },
        "modal": {
            "confirm": {
                "header": "Nouvelle demande de fonctionnalité",
                "body": "Cette demande de fonctionnalité doit être soumise au moins 21 jours avant la première date (exclusive ou générale, quelle qu'elle soit). Malheureusement, les soumissions tardives ne peuvent pas être prises en compte. Voulez-vous soumettre votre demande de fonctionnalité ?"
            }
        }
    }
};

export default featureFR;